import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { Chart, ChartConfiguration, ChartType } from "chart.js";

@Component({
    selector: "app-donut-chart",
    templateUrl: "./donut-chart.component.html",
    styleUrls: ["./donut-chart.component.scss"],
    standalone: false
})
export class DonutChartComponent implements AfterViewInit {
  @Input() dataLabel: string[] = [];
  @Input() data: number[] = [];

  @ViewChild("doughnutCanvas", {static: true}) doughnutCanvas!: ElementRef<HTMLCanvasElement>;
  private chart!: Chart;

  constructor() {}

  ngAfterViewInit() {
    this.createChart();
  }

  private createChart() {
    this.chart = new Chart(this.doughnutCanvas.nativeElement, {
      type: "doughnut" as ChartType,
      data: {
        labels: this.dataLabel,
        datasets: [
          {
            data: this.data,
            backgroundColor: ["#5a8cfe", "#00205c"],
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
      } as ChartConfiguration["options"],
    });
  }
}
